import { useEffect, useState } from 'react';
import IconDelete from '@/assets/icon/icon-delete-circle.svg';
import { Button } from '@/shared/components/ui/Button';
import DetailForm from '@/shared/components/ui/DetailForm/DetailForm';
import type { Option as DetailFormOption } from '@/shared/components/ui/DetailForm/DetailForm.types';
// import GeneralInput from "@/components/GeneralInput/GeneralInput";
import GeneralInput from '@/shared/components/ui/GeneralInput/GeneralInput';
import type { DynamicFormProps } from './DynamicForm.types';

const DynamicForm = ({
  //index,
  onDelete,
  handleRoadInputChange,
  road_id,
  name,
  crosswalk_length,
  crosswalk_width,
  traffic_light,
  incoming_direction,
  incoming_direction_sub1,
  incoming_direction_sub2,
  incoming_direction_sub3,
  incoming_direction_sub4,
  incoming_direction_sub5,
  incoming_direction_sub6,
  incoming_direction_sub7,
  incoming_direction_sub8,
  incoming_direction_sub9,
  incoming_direction_sub10,
  //site_id,
  crosswalk,
  incoming_compass,
  outgoing_compass,
  incoming_lane_cnt,
  outgoing_lane_cnt,
  mapped_detector,
  // mapped_vms, // 전광판 비활성
  mapped_logojector,
  mapped_speaker,
  directionOptions,
  crosswalkPresenceOptions,
  pedestrianSignalPresenceOptions,
}: DynamicFormProps) => {
  const [directionValues, setDirectionValues] = useState({
    incoming_direction_sub1: '',
    incoming_direction_sub2: '',
    incoming_direction_sub3: '',
    incoming_direction_sub4: '',
    incoming_direction_sub5: '',
    incoming_direction_sub6: '',
    incoming_direction_sub7: '',
    incoming_direction_sub8: '',
    incoming_direction_sub9: '',
    incoming_direction_sub10: '',
  });

  useEffect(() => {
    if (incoming_direction) {
      setDirectionValues({
        incoming_direction_sub1: incoming_direction_sub1 || '',
        incoming_direction_sub2: incoming_direction_sub2 || '',
        incoming_direction_sub3: incoming_direction_sub3 || '',
        incoming_direction_sub4: incoming_direction_sub4 || '',
        incoming_direction_sub5: incoming_direction_sub5 || '',
        incoming_direction_sub6: incoming_direction_sub6 || '',
        incoming_direction_sub7: incoming_direction_sub7 || '',
        incoming_direction_sub8: incoming_direction_sub8 || '',
        incoming_direction_sub9: incoming_direction_sub9 || '',
        incoming_direction_sub10: incoming_direction_sub10 || '',
      });
    }
  }, [
    incoming_direction,
    incoming_direction_sub1,
    incoming_direction_sub2,
    incoming_direction_sub3,
    incoming_direction_sub4,
    incoming_direction_sub5,
    incoming_direction_sub6,
    incoming_direction_sub7,
    incoming_direction_sub8,
    incoming_direction_sub9,
    incoming_direction_sub10,
  ]);

  const sortedOptions = (_type: string, compass: string) => {
    const selectedOption = directionOptions.find((option) => option.value === compass);
    const otherOptions = directionOptions.filter((option) => option.value !== compass);

    return selectedOption ? [selectedOption, ...otherOptions] : directionOptions;
  };

  const generateInputFields = () => {
    // const fields = [];
    const fields: JSX.Element[] = [];
    for (let i = 1; i <= incoming_lane_cnt; i++) {
      fields.push(
        <GeneralInput
          inputFormStyle={'w-[80px]'}
          key={`incoming_direction_sub${i}`}
          customInput=""
          placeholder={`좌,우,직`}
          name={`incoming_direction_sub${i}`}
          pattern="^(?!.*\d).*$"
          onChange={handleRoadInputChange}
          // value={String(directionValues[`incoming_direction_sub${i}` as keyof typeof directionValues] ?? "")}
          value={directionValues[`incoming_direction_sub${i}` as keyof typeof directionValues]}
        />
      );
    }
    return fields;
  };

  return (
    <div className="grid grid-cols-3 gap-[50px]">
      <div className="w-full grid col-span-1">
        <div className="flex flex-row items-start gap-[20px]">
          <Button
            variant="ghost"
            type="button"
            className="_boxImgDelete w-fit p-0 h-auto hover:bg-transparent cursor-pointer hover:opacity-80"
            onClick={() => onDelete()}
          >
            <img src={IconDelete} alt="" />
          </Button>
          <div className="flex w-full items-center flex-col gap-[12px]">
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                className="items-center!"
                styleLabel="w-[124px]!"
                label="접근로 ID "
                inputType="text"
                name="road_id"
                disabled={true}
                value={road_id}
                onChange={handleRoadInputChange}
              />
            </div>
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                inputType="text"
                className="items-center!"
                label="진입/진출 차선 수"
                required={true}
                styleLabel="w-[124px]!"
                showInput={false}
              >
                <div className="flex w-full flex-row gap-x-2">
                  <DetailForm
                    inputType="select"
                    className="items-center!"
                    label="유형"
                    showTitle={false}
                    required={true}
                    optionSelect={[
                      { label: '10', value: '10' },
                      { label: '9', value: '9' },
                      { label: '8', value: '8' },
                      { label: '7', value: '7' },
                      { label: '6', value: '6' },
                      { label: '5', value: '5' },
                      { label: '4', value: '4' },
                      { label: '3', value: '3' },
                      { label: '2', value: '2' },
                      { label: '1', value: '1' },
                    ]}
                    //onChange={(e) => console.log("Selected:", e.target.value)}
                    name="incoming_lane_cnt"
                    value={incoming_lane_cnt || 2}
                    onChange={handleRoadInputChange}
                  />
                  <DetailForm
                    inputType="select"
                    className="items-center!"
                    label="유형"
                    showTitle={false}
                    required={true}
                    optionSelect={[
                      { label: '10', value: '10' },
                      { label: '9', value: '9' },
                      { label: '8', value: '8' },
                      { label: '7', value: '7' },
                      { label: '6', value: '6' },
                      { label: '5', value: '5' },
                      { label: '4', value: '4' },
                      { label: '3', value: '3' },
                      { label: '2', value: '2' },
                      { label: '1', value: '1' },
                    ]}
                    //onChange={(e) => console.log("Selected:", e.target.value)}
                    name="outgoing_lane_cnt"
                    value={outgoing_lane_cnt || 2}
                    onChange={handleRoadInputChange}
                  />
                </div>
              </DetailForm>
            </div>
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                inputType="text"
                className="items-center!"
                label="횡단보도 유무"
                required={true}
                styleLabel="w-[124px]!"
                showInput={false}
              >
                <div className="flex w-full flex-row gap-x-2">
                  <DetailForm
                    inputType="select"
                    className="items-center!"
                    label="유형"
                    showTitle={false}
                    required={true}
                    name="crosswalk"
                    optionSelect={
                      (crosswalk === '105001'
                        ? crosswalkPresenceOptions
                        : [...crosswalkPresenceOptions].reverse()) as unknown as DetailFormOption[]
                    }
                    value={crosswalk || '105002'} // 기본값 "미존재" 선택
                    onChange={handleRoadInputChange}
                    //onChange={(e) => console.log("Selected:", e.target.value)}
                  />
                </div>
              </DetailForm>
            </div>
            <DetailForm
              inputType="text"
              className="items-center!"
              styleLabel="w-[124px]!"
              label="매핑 검지기"
              //placeholder="DT01001(ID0003)"
              value={mapped_detector || ''}
              name="mapped_detector"
              disabled={true}
              onChange={handleRoadInputChange}
            />
          </div>
        </div>
      </div>

      <div className="col-span-2 w-full gap-y-[12px] grid items-start">
        <div className="grid grid-cols-2 gap-[50px]">
          <div className="flex flex-row items-center gap-[20px]">
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                inputType="text"
                className="items-center!"
                styleLabel=""
                label="명칭 "
                required={true}
                placeholder="북쪽 접근로"
                name="name"
                maxLength={100}
                value={name}
                onChange={handleRoadInputChange}
              />
            </div>
          </div>
          <div className="flex flex-row items-center gap-[20px]">
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                inputType="text"
                className="items-center!"
                label="진입/진출 방향"
                required={true}
                showInput={false}
              >
                <div className="flex w-full flex-row gap-x-2">
                  <DetailForm
                    inputType="select"
                    className="items-center!"
                    showTitle={false}
                    required={true}
                    optionSelect={
                      sortedOptions('incoming', incoming_compass) as unknown as DetailFormOption[]
                    } // 동적으로 옵션 순서 조정
                    //onChange={(e) => console.log("Selected:", e.target.value)}
                    name="incoming_compass"
                    value={incoming_compass || '103001'}
                    onChange={handleRoadInputChange}
                  />
                  <DetailForm
                    inputType="select"
                    className="items-center!"
                    showTitle={false}
                    required={true}
                    optionSelect={
                      sortedOptions('outgoing', outgoing_compass) as unknown as DetailFormOption[]
                    } // 동적으로 옵션 순서 조정
                    //onChange={(e) => console.log("Selected:", e.target.value)}
                    name="outgoing_compass"
                    value={outgoing_compass || '103002'}
                    onChange={handleRoadInputChange}
                  />
                </div>
              </DetailForm>
            </div>
          </div>
        </div>

        <div className="flex w-full flex-row gap-x-4">
          <DetailForm
            inputType="text"
            className="items-center!"
            label="진입 진행 방향"
            required={true}
            showInput={false}
          >
            <div className="flex w-full flex-row gap-x-2">{generateInputFields()}</div>
          </DetailForm>
        </div>

        <div className="grid grid-cols-2 gap-[50px]">
          <div className="flex flex-row items-center gap-[20px]">
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                inputType="text"
                className="items-center!"
                label="횡단 보도 길이 / 폭"
                name="crosswalk"
                required={true}
                showInput={false}
              >
                <div className="flex w-full flex-row gap-x-2">
                  <GeneralInput
                    customInput="w-full"
                    placeholder=""
                    name="crosswalk_length"
                    pattern="^[0-9]*\.?[0-9]*$" // 숫자와 온점만 허용하는 정규식
                    // title="숫자와 온점만 입력 가능합니다." // 사용자가 잘못된 값을 입력할 경우 안내
                    disabled={crosswalk === '105002'}
                    onChange={handleRoadInputChange}
                    value={crosswalk_length}
                  />
                  <GeneralInput
                    customInput="w-full"
                    placeholder=""
                    name="crosswalk_width"
                    pattern="^[0-9]*\.?[0-9]*$" // 숫자와 온점만 허용하는 정규식
                    // title="숫자와 온점만 입력 가능합니다." // 사용자가 잘못된 값을 입력할 경우 안내
                    disabled={crosswalk === '105002'}
                    onChange={handleRoadInputChange}
                    value={crosswalk_width}
                  />
                </div>
              </DetailForm>
            </div>
          </div>
          <div className="flex flex-row items-center gap-[20px]">
            <div className="flex w-full flex-row gap-x-4">
              <DetailForm
                inputType="text"
                className="items-center!"
                label="보행자 신호등 유무"
                required={true}
                showInput={false}
                name="traffic_light"
              >
                <div className="flex w-full flex-row gap-x-2">
                  <DetailForm
                    inputType="select"
                    className="items-center!"
                    name="traffic_light"
                    showTitle={false}
                    required={true}
                    optionSelect={
                      (traffic_light === '106001'
                        ? pedestrianSignalPresenceOptions
                        : [
                            ...pedestrianSignalPresenceOptions,
                          ].reverse()) as unknown as DetailFormOption[]
                    }
                    value={traffic_light || '106002'}
                    onChange={handleRoadInputChange}
                  />
                </div>
              </DetailForm>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-[50px]">
          <div className="flex flex-row items-center gap-[20px]">
            <div className="flex w-full flex-row gap-x-4">
              {/* 전광판 비활성
              <DetailForm
                inputType="text"
                className="items-center!"
                label="매핑 전광판"
                name="mapped_vms"
                disabled={true}
                onChange={handleRoadInputChange}
                value={mapped_vms}
              /> */}
              <DetailForm
                inputType="text"
                className="items-center!"
                label="매핑 로고젝터"
                name="mapped_logojector"
                disabled={true}
                onChange={handleRoadInputChange}
                value={mapped_logojector}
              />
            </div>
          </div>
          <div className="flex flex-row items-center gap-[20px]">
            <DetailForm
              inputType="text"
              className="items-center!"
              label="매핑 스피커"
              name="mapped_speaker"
              //placeholder="DT01001(ID0003)"
              disabled={true}
              onChange={handleRoadInputChange}
              value={mapped_speaker}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicForm;
